// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".FocusedNav-cls1___40c26c83e3c07d32ff7{/*!*/}.FocusedNav-cls2___0498f16541550f10a3b{max-height:80px;max-width:100vw;background-color:#fff;padding:16px}.FocusedNav-cls2___0498f16541550f10a3b.FocusedNav-inDevStyle___b5c86562e0b2b6da8ba{background-color:aqua}.FocusedNav-cls2___0498f16541550f10a3b.FocusedNav-useGrid___65ed2088c99e7ece0e2{padding:16px 0}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "FocusedNav-cls1___40c26c83e3c07d32ff7",
	"cls2": "FocusedNav-cls2___0498f16541550f10a3b FocusedNav-cls1___40c26c83e3c07d32ff7",
	"inDevStyle": "FocusedNav-inDevStyle___b5c86562e0b2b6da8ba",
	"useGrid": "FocusedNav-useGrid___65ed2088c99e7ece0e2"
};
export default ___CSS_LOADER_EXPORT___;
